import { TaskMetaInformation } from './task-meta-information.interface';

export interface ExportTasksExcelData {
    task: TaskMetaInformation;
    documentNames?: string[];
    annotations?: string[];
}
